import { BREB_KEY_SOURCE_NAME } from "@/shared/components/payments/breb-key/brebKeySources";
import useTranslations from "@/shared/lang/useTranslations";

import type { PayinBrebDetail } from "../services/paymentsPayin.service";

export interface PayinBrebOrigin {
  channel: string | null;
  /** The organization key the payment reached, with its type when known: "@coloca… · Document". */
  receivingKey: string | null;
  payer: string | null;
}

export function usePayinBrebOrigin(breb: PayinBrebDetail | null | undefined): PayinBrebOrigin {
  const { t } = useTranslations("payins");
  if (!breb) return { channel: null, receivingKey: null, payer: null };

  let channel: string | null = null;
  if (breb.channel === "QR") channel = t("payin_detail_channel_qr");
  if (breb.channel === "STATIC_QR") channel = t("payin_detail_channel_static_qr");
  if (breb.channel === "KEY") channel = t("payin_detail_channel_key_unnamed");

  const source = breb.receiving_key_source;
  const receivingKey = breb.receiving_key
    ? source
      ? `${breb.receiving_key} · ${t(BREB_KEY_SOURCE_NAME[source])}`
      : breb.receiving_key
    : null;

  const payer = [breb.payer_name, breb.payer_bank_name].filter(Boolean).join(" · ") || null;
  return { channel, receivingKey, payer };
}
